<script setup lang="ts">
import RuleItem from "@/components/submission/RuleItem.vue";
import { onMounted, ref } from "vue";
import YellowCap from "@/components/caps/YellowCap.vue";
import BlueCap from "@/components/caps/BlueCap.vue";

const animatedElement = ref<HTMLElement | null>(null);

onMounted(() => {
  const ANIMATION_TYPES = {
    left: "animate__fadeInLeft",
    right: "animate__fadeInRight"
  } as const;

  const handleIntersection = (target: Element, index: number) => {
    const direction = target.getAttribute('data-animate-direction') || 'left';
    const animationClass = ANIMATION_TYPES[direction as keyof typeof ANIMATION_TYPES];
    const delay = index * 0.2;

    target.classList.add("animate__animated", animationClass);
    (target as HTMLElement).style.setProperty('--animate-delay', `${delay}s`);
    target.classList.add('animate__delay');
  };

  const observer = new IntersectionObserver(
      (entries: IntersectionObserverEntry[]) => {
        entries
            .filter(entry => entry.isIntersecting && entry.intersectionRatio > 0.8)
            .forEach((entry, index) => handleIntersection(entry.target, index));
      },
      {
        threshold: 0.8,
        rootMargin: '-100px 0px'

      }
  );

  const elements = Array.from(document.querySelectorAll('#rules [data-animate-direction]'));
  elements.forEach((element, index) => {
    element.classList.add('opacity-0');
    observer.observe(element);
  });
});
</script>

<template>
  <section id="rules" class="rounded-5xl text-center relative rounded-b-[60px]">
    <div class="bg-white rounded-t-[70px] relative" style="background: linear-gradient(0deg, rgba(2, 0, 36, 0) 0%, rgba(242,237,228, 1) 70%, rgba(242,237,228, 1) 100%);">
      <h1 class="text-5xl pb-4 absolute top-0 left-1/2 -translate-x-1/2 mt-4">Zasady</h1>
      <img src="@/assets/images/wioska.webp" class="transform-[translateY(-30px)]"/>
      <img src="@/assets/images/koziol.webp" class="w-[30%] block absolute left-1/2 -translate-x-1/2 bottom-12"/>
    </div>
    <div class="bg-rules px-12 transform-[translateY(-60px)] relative">

      <img data-animate-direction="right" src="../../assets/images/rules/dom-1.webp" class="absolute right-0 w-60 -z-1" >
      <img data-animate-direction="left" src="../../assets/images/rules/dom-2.webp" class="absolute left-0 top-20 w-38 -z-1" >
      <img data-animate-direction="left" src="../../assets/images/rules/dom-3.webp" class="absolute left-0 w-28 bottom-24 -z-1" >

      <div class="grid grid-cols-[20%_80%] gap-x-2 gap-y-16 max-w-md mx-auto">
        <RuleItem :key="1" item-number="1" item-content="Kup 2 dowolne<br/> piwa Kozel<br/> z Żappką"></RuleItem>
        <RuleItem :key="2" item-number="2" item-content="Odbierz<br/> i zarejestruj<br/> kod z Żappki"></RuleItem>
        <RuleItem :key="3" item-number="3"
                  item-content="Wejdź do świata<br/> 3D Kozla i&nbsp;zagraj<br/> o&nbsp;nagrody prosto <br/> z&nbsp;wirtualnej <br/>rzeczywistości"
        ></RuleItem>
      </div>

      <div class="flex justify-center relative max-w-[200px] mx-auto">
        <img src="@/assets/images/telefon.webp" class="max-h-[200px] block top-8 relative" alt="Zdjęcie przedstawiające komórkę">
        <YellowCap class="absolute w-[80px] -right-10 top-14" />
        <BlueCap class="absolute w-[120px] -right-12 -bottom-4" />
      </div>

      <div class="flex flex-col gap-4 relative top-10">
        <div class="flex flex-col gap-1 leading-none">
          <div class="apex-item">Zakupu należy dokonać w okresie</div>
          <div class="apex-item">02-08.04.2025 r.</div>
        </div>
        <div class="flex flex-col gap-1 leading-none">
          <div class="apex-item">Zgłoszenia należy dokonać w okresie</div>
          <div class="apex-item">02-10.04.2025 r.</div>
        </div>
      </div>

    </div>
  </section>
</template>

<style scoped>
.bg-village {
  background-image: url("../../assets/images/wioska.webp");
}

.apex-item {
  font-family: 'ApexSerif', 'serif';
  font-weight: 800;
}


#rules {
  background-image: url("../../assets/images/droga.webp");
  background-size: cover;
  background-position: 0 80px;
  background-repeat: no-repeat;
}

.bg-rules {
  position: relative;
}

.bg-rules::before {
  content: '';
  position: absolute;
  max-width: 400px;
  width: 100%;
  height: calc(100% + 50px);
  background: url("../../assets/images/rules/bg.webp");
  border-radius: 12px;
  background-size: cover;
  z-index: -1;
  left: 50%;
  transform: translateY(-180px);
  opacity: 0.8;
  translate: -50%;
}
</style>